import { render } from "./CareAssistants.vue?vue&type=template&id=7cbf2c98&scoped=true"
import script from "./CareAssistants.vue?vue&type=script&lang=js"
export * from "./CareAssistants.vue?vue&type=script&lang=js"

import "./CareAssistants.vue?vue&type=style&index=0&id=7cbf2c98&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-7cbf2c98"]])

export default __exports__